<script>
import TwButton from '@/components/generic/tw-button.vue'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import { useFundraiserPageStore } from '@/stores/fundraiserPage.js'
import { useAuthStore } from '@/stores/auth.js'

export default {
  name: 'FundraiserPagePublishButton',
  components: { TwButton },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: 'default',
    }
  },
  emits: ['updated', 'published','unpublished'],
  data() {
    return {
      Loading: false,
      ValidationErrorMessage: null
    }
  },
  computed: {
    fundraiser() {
      return this.fundraiserPage.fundraiser
    },
    publishingEnabled() {
      if(useAuthStore().user.admin || useAuthStore().user.role_organization) {
        return true
      }
      if (this.fundraiser && this.fundraiser.settings && this.fundraiser.settings.lock_publishing === true) {
        return false
      }
      return true
    }
  },
  methods: {
    async publishFundraiser() {
      try {
        if(confirm('Are you sure you want to publish this fundraiser?')) {
          this.Loading = true
          const fundraiserPage = await useFundraiserPageStore().fundraiserPagePublish(this.fundraiserPage.id)
          this.Loading = false
          this.$emit('published', fundraiserPage)
          this.$emit('updated', fundraiserPage)
        }
      } catch (e) {
        console.error(e)
        this.Loading = false
      }
    },
    async unpublishFundraiser() {
      try {
        if(confirm('Are you sure you want to unpublish this fundraiser?')) {
          this.Loading = true
          const fundraiserPage = await useFundraiserPageStore().fundraiserPageUnPublish(this.fundraiserPage.id)
          this.Loading = false
          this.$emit('unpublished', fundraiserPage)
          this.$emit('updated', fundraiserPage)
        }
      } catch (e) {
        console.error(e)
        this.Loading = false
      }
    }
  }
}
</script>

<template>
  <tw-button v-if="fundraiserPage.published && publishingEnabled" :size="size" variant="secondary" @click="unpublishFundraiser">
    <icon icon="file-lines" /> Unpublish
  </tw-button>
  <tw-button v-else-if="!fundraiserPage.published && publishingEnabled" :size="size" variant="amber" @click="publishFundraiser">
    <icon icon="file-lines" /> Publish
  </tw-button>
</template>

<style scoped>

</style>
